import Vue from 'vue';
import Router from 'vue-router';
import MainMenu from '@/components/main-menu/main-menu';
import HomeTab from '@/components/main-menu/home-tab/home-tab';
import HistoryTab from '@/components/main-menu/history-tab/history-tab';
import SettingsTab from '@/components/main-menu/settings-tab/settings-tab';
import BroadcastingTab from '@/components/main-menu/broadcasting-tab/broadcasting-tab';
import Room from '@/components/room/room';
import { REMOTE_PATHS } from '@/constants/remote-paths.constant';

Vue.use(Router);

const router = new Router({
  root: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home-tab',
      meta: {auth: true, redirect: 'MainMenu'}
    },
    {
      path: '/:username',
      component: MainMenu,
      meta: {auth: true},
      children: [
        {
          path: '',
          name: 'MainMenu',
          component: HomeTab
        },
        {
          path: '/history',
          name: 'HistoryTab',
          component: HistoryTab
        },
        {
          path: '/settings',
          name: 'SettingsTab',
          component: SettingsTab
        },
        {
          path: '/broadcast',
          name: 'BroadcastingTab',
          component: BroadcastingTab
        }
      ]
    },
    {
      path: '/c/:username/:pin',
      name: 'Room',
      component: Room,
      meta: {auth: true}
    },
    {path: '*', redirect: '/'}
  ]
});

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some(route => route.meta.auth);
  const authed = Vue.prototype.$cookie.get('accessToken');
  if (to.meta.redirect === 'MainMenu' && authed) {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    if (user && user.username) {
      next({
        name: 'MainMenu',
        params: {username: user.username}
      });
    }
  }
  if (authRequired && !authed) {
    Vue.prototype.$cookie.delete('accessToken');
    window.location.href = `${REMOTE_PATHS.AUTH_PATH}${window.location.pathname}`;
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js